export const PHP_DATA_SLICE_KEY = "ph";

export const PHP_PAYMENT_METHODS: { label: string; value: string; disabled?: boolean }[] = [
  { label: "Bank transfer", value: "bank" },
  { label: "eWallet", value: "wallet" },
];

export const PHP_WALLET_PROVIDERS = [
  { label: "GCash", value: "gcash_php" },
  { label: "GrabPay", value: "grabpay_php" },
  { label: "PayMaya", value: "paymaya_php" },
  { label: "ShopeePay", value: "shopeepay_php" },
];

export const PHP_SOURCE_OF_FUNDS = [
  { label: "Business Income", value: "Business Income" },
  { label: "Business Revenue", value: "Business Revenue" },
  { label: "Personal Savings", value: "Personal Savings" },
];

export const PHP_BENEFICIARY_TYPES = [
  { label: "Individual", value: "Individual" },
  { label: "Business", value: "Business" },
];

export const PHP_SOURCE_CURRENCIES = [{ label: "USD", value: "USD" }];
